
    <div class="Customers master-data">
      <div class="ui-g-12 ui-lg-12 ui-g-nopad customers-steps">
        <p-steps [style]="{'width': '100%'}" [model]="tabs" [(activeIndex)]="activeTabIndex" [readonly]="false"></p-steps>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== 0">
        <kv-loyalty-domiciliation-single
          *ngIf="activeTabIndex == 0"
        ></kv-loyalty-domiciliation-single>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== 1">
        <kv-loyalty-domiciliation-massive-range
          *ngIf="activeTabIndex == 1"
        ></kv-loyalty-domiciliation-massive-range>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== 2">
        <kv-loyalty-domiciliation-massive-store
          *ngIf="activeTabIndex == 2"
        ></kv-loyalty-domiciliation-massive-store>
      </div>
    </div>
    
      
  


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-domiciliation/loyalty-domiciliation.component.ts.LoyaltyDomiciliationComponent.html